export const IMAGE_SIZE_LAZY = "LAZY";
export const IMAGE_SIZE_SMALL = "SMALL";
export const IMAGE_SIZE_LARGE = "LARGE";
export const IMAGE_SIZE_RAW = "RAW";

const imagesBase = "/images";

export function imageUrl(image, size = IMAGE_SIZE_RAW) {
  if (!image || !image.path) {
    return null;
  }

  switch (size) {
    case IMAGE_SIZE_LAZY:
      return `${imagesBase}/lazy_${image.path}`;
    case IMAGE_SIZE_SMALL:
      return `${imagesBase}/sm_${image.path}`;
    case IMAGE_SIZE_LARGE:
      return `${imagesBase}/lg_${image.path}`;
    case IMAGE_SIZE_RAW:
    default:
      return `${imagesBase}/${image.path}`;
  }
}

export function recipeImageUrl(recipe, size = IMAGE_SIZE_RAW) {
  return recipe && recipe.image && recipe.image.data;
  // return (
  //   recipe &&
  //   recipe.images &&
  //   recipe.images.length &&
  //   recipe.images[0] &&
  //   imageUrl(recipe.images[0], size)
  // );
}
